import styled, {css} from 'styled-components'

export const StyledHistoryWrapper = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 4}px;
        padding: ${theme.spacing * 6}px;
    `}
`

export const StyledBatchList = styled.div`
    ${({theme}) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing * 2}px;
    `}
`

export const StyledBatchCard = styled.button`
    ${({theme}) => css`
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: ${theme.spacing * 3}px;
        padding: ${theme.spacing * 3}px;
        border: 1px solid ${theme.palette.neutral['200']};
        border-radius: 8px;
        background: ${theme.palette.neutral.white};
        cursor: pointer;
        text-align: left;
        transition: ${theme.transition};

        &:hover {
            background: ${theme.palette.neutral['50']};
            border-color: ${theme.palette.primary['300']};
        }
    `}
`

export const StyledBatchCardMain = styled.div`
    ${({theme}) => css`
        min-width: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing}px;

        & > small {
            ${theme.typography.textXs};
            color: ${theme.palette.neutral['500']};
        }

        & > strong {
            ${theme.typography.textSm};
            font-weight: 500;
            color: ${theme.palette.neutral['900']};
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        & > span {
            ${theme.typography.textXs};
            color: ${theme.palette.neutral['500']};
        }
    `}
`

export const StyledBatchCardAside = styled.div`
    ${({theme}) => css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing * 2}px;
        flex-shrink: 0;

        & > svg {
            width: 16px;
            height: 16px;
            color: ${theme.palette.neutral['400']};
        }
    `}
`

export const StyledStatusPill = styled.span<{$status: 'sent' | 'partial' | 'sending'}>`
    ${({theme, $status}) => css`
        padding: ${theme.spacing}px ${theme.spacing * 2}px;
        border-radius: 6px;
        ${theme.typography.textXs};
        font-weight: 500;
        background: ${$status === 'sent'
            ? theme.palette.success['50']
            : $status === 'partial'
              ? theme.palette.warning['50']
              : theme.palette.neutral['100']};
        color: ${$status === 'sent'
            ? theme.palette.success['700']
            : $status === 'partial'
              ? theme.palette.warning['700']
              : theme.palette.neutral['600']};
    `}
`

export const StyledPaginationBar = styled.div`
    ${({theme}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        gap: ${theme.spacing * 2}px;

        & > span {
            ${theme.typography.textXs};
            color: ${theme.palette.neutral['500']};
        }
    `}
`

export const StyledOpensPlaceholder = styled.span`
    cursor: help;
`
